module.exports = __webpack_public_path__ + "static/industry02-9aebafc0da6c9dc0445beca92457e622.png";